import { defineSlotRecipe } from "@pandacss/dev";

export const popoverSlots = ["container", "positioner", "root"];

export const aromaPopover = defineSlotRecipe({
  className: "aroma-popover",
  jsx: ["Popover"],
  slots: popoverSlots,
  base: {
    root: {},
    container: {
      borderRadius: "xl",
      shadow: "effect.shadow.bold-bottom",
      backgroundColor: "background.neutral.base.subtlest",
    },
    positioner: {
      zIndex: "var(--popover-z-index) !important",
    },
  },
  variants: {
    size: {
      small: {
        container: {
          width: "width.2xs",
          maxWidth: "width.2xs",
          backgroundColor: "background.neutral.base.subtlest",
        },
      },
      middle: {
        container: {
          width: "width.s",
          maxWidth: "width.s",
        },
      },
      large: {
        container: {
          width: "width.m",
          maxWidth: "width.m",
        },
      },
    },
  },
  defaultVariants: {
    size: "middle",
  },
});
